import { takeEvery, fork, put, all } from 'redux-saga/effects';
import * as actionType from './actionTypes';
import * as action from './actions';
import { api } from 'api';
import { AxiosResponse } from 'axios';
import { apiResError } from '../actions';
import { MaintenanceMessage } from 'api';

function* fetchMaintenanceStatus() {
	try {
		const response: AxiosResponse<MaintenanceMessage[]> =
			yield api.utils.apiUtilsGetMaintenanceStatusGet();
		yield put(action.setMaintenanceStatus(response.data));
	} catch (error: any) {
		yield put(apiResError(error.message));
	}
}

export function* watchFetchMaintenanceStatus() {
	yield takeEvery(actionType.GET_MAINTENANCE_STATUS, fetchMaintenanceStatus);
}

function* maintenanceSaga() {
	yield all([fork(watchFetchMaintenanceStatus)]);
}

export default maintenanceSaga;
